import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Page from "../../../pages/Page";
import { getLinkParentUrl, PageTitle } from "../../../components/Utils";
import {
  getContentComponent,
  getContentTypeFromId,
  PageMenu,
  PageMetaData,
  PAGE_TYPES,
} from "../components/Utils";
import PageForm from "../components/PageForm";
import { FormMenu, SecondaryButton } from "../../../components/Buttons";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import {
  loadContent,
  saveContent,
  createOrUpdatePagePath,
  // savePathToArchive,
  showPathMovementDialog,
  editPageContent,
  cancelPageContent,
  deletePagePathAndContent
} from "../actions";
import { getTreeNode } from "../../MainNav";

import "../styles.css";

export default function StaticPageFactory(
  key,
  label,
  type = "default",
  subLinks = [],
  editValidators = [],
  linkData = {},
  treeData = { links: [], tree: {} }
) {
  const treeNode = getTreeNode(linkData.url, treeData.tree);
  const nrChildren = ((treeNode || {}).children || [])
    .filter(item => (item.is_archived === undefined || item.is_archived === 0))
    .length;
  const { nrSiblings } = treeData || {};
  console.log("StaticPageFactory()", { nrChildren }, linkData, treeNode, treeData);
  const randomId = `${Math.random()}`.split(".").join("_");
  const pageId = `page-${randomId}`;

  const StaticPage = ({
    user,
    disabled,
    content,
    isEditing,
    history,
    saveContent,
    createOrUpdatePath,
    // saveToArchive,
    moveSubTree,
    editPage,
    cancelPage,
    deletePage,
  }) => {
    const formRef = useRef(null);

    useEffect(() => {
      scrollToTop();
      return () => {
        cancelPage();
      };
    }, []);

    const scrollToTop = () => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    const onEdit = () => {
      editPage();
    };

    const onCancel = () => {
      cancelPage();
    };

    const onSave = () => {
      const data = formRef.current ? formRef.current.getModel() : null;
      if (!data) return null;
      // set creator and modifier id
      data.modified_by_user_id = user.id;
      if (!data.id) {
        data.created_by_user_id = user.id;
      }
      const model = { pathname: key, ...data };
      console.log("StaticPage.onSave()", model);
      saveContent(model);
    };

    const renderEditingDefault = (editContent) => {
      return (
        <PageForm
          pageId={pageId}
          className="clearfix w3-border no-border-top pad-big"
          ref={formRef}
          model={editContent}
        />
      );
    };

    const renderEditing = () => {
      return (
        <div id={pageId} className="clearfix pos-rel">
          <div className="clearfix w3-border-bottom w3-border-left w3-border-right pad bg-primary">
            <FormMenu
              className="w3-right"
              saveBtnName="saveStaticPageBtn2"
              onSave={onSave}
              onCancel={onCancel}
            />
            <h3 className="no-margin pad-lft pad-sm-top">
              {"Seiteninhalt bearbeiten"}
            </h3>
          </div>
          {renderEditingDefault(content)}
          <FormMenu
            className="w3-border margin-big-top pad"
            saveBtnName="saveStaticPageBtn"
            onSave={onSave}
            onCancel={onCancel}
          />
        </div>
      );
    };

    const renderDisplayDefault = (contents, created_date) => {
      const markup =
        contents &&
        contents.length > 0 &&
        contents.map((item, index) => {
          if (!item) {
            return null;
          }
          const { content_type_id, ...model } = item;
          const itemType = getContentTypeFromId(content_type_id);
          const Component = getContentComponent(itemType);
          if (!Component) {
            console.error(
              "<< Content Type Error: unknown content type",
              itemType,
              item
            );
            return null;
          }
          const createdDate = moment(
            created_date,
            "YYYY-MM-DDTHH:mm:ss:SSSZ"
          ).format("DD.MM.YYYY");
          return (
            <Component
              key={index}
              className="margin-big-top"
              model={model}
              pageCreated={createdDate}
            />
          );
        });
      return <div style={{ minHeight: "240px" }}>{markup}</div>;
    };

    const renderDisplay = (isEditable, displayContent) => {
      const {
        title,
        subtitle,
        contents,
        modified_by_user_name,
        modified_date,
        created_date,
      } = displayContent;

      const pageTitle = title;
      const bodyMarkup = renderDisplayDefault(contents, created_date);
      const contentDates = [];
      (contents || []).forEach((item) => {
        item && contentDates.push(item.modified_date || item.created_date);
      });
      return (
        <Page id="currentStaticPage" title={pageTitle} description={pageTitle}>
          <PageTitle noMarginTop>
            <PageMenu
              contents={contents}
              isVisible={isEditable}
              type={type}
              linkData={linkData}
              onEditPageContent={onEdit}
              onEditPageLink={() =>
                createOrUpdatePath({
                  linkData,
                  config: {
                    type: PAGE_TYPES.DEFAULT,
                    nrSiblings,
                  },
                })
              }
              onCreatePageSubLink={() =>
                createOrUpdatePath({
                  parentUrl: key,
                  config: { nrChildren: nrChildren + 1 },
                })
              }
              // onMoveToArchive={(...args) =>
              //   saveToArchive(...args, () =>
              //     history.replace(getLinkParentUrl(linkData.url))
              //   )
              // }
              onMoveSubTree={() =>
                moveSubTree({ linkData, treeLinks: treeData.links })
              }
              onDeletePage={(...args) =>
                deletePage(...args, () =>
                  history.replace(getLinkParentUrl(linkData.url))
                )
              }
            />
            <h3 className="no-margin pad-sm-top">{pageTitle}</h3>
          </PageTitle>
          <div className="w3-border no-border-top pad-big clearfix">
            <p className="no-margin">{subtitle}</p>
            {bodyMarkup}
            <div className="pad-big-top">
              <SecondaryButton
                className="w3-right"
                size="small"
                onClick={scrollToTop}
              >
                {`nach oben`}
              </SecondaryButton>
              <PageMetaData
                modifiedBy={modified_by_user_name}
                createdDate={created_date}
                modifiedDate={modified_date}
                contentsModified={contentDates}
              />
            </div>
          </div>
          </Page>
      );
    };

    if (!content) return null;
    let isEditable = false;
    if (disabled === undefined) {
      if (editValidators && editValidators.length > 0) {
        let isValid = false;
        editValidators.forEach((func) => {
          isValid = isValid || func(user);
        });
        isEditable = isEditable || isValid;
      } else {
        isEditable = true;
      }
    } else {
      isEditable = !disabled;
    }
    console.log("StaticPage.render()", disabled, editValidators, isEditable, key, label);
    return (
      <div className="clearfix">
        <div></div>
        {isEditing
          ? renderEditing()
          : renderDisplay(isEditable, content)}
      </div>
    );
  };

  StaticPage.propTypes = {
    user: PropTypes.object,
    disabled: PropTypes.bool,
    content: PropTypes.object,
    isEditing: PropTypes.bool,
    history: PropTypes.object.isRequired,
    getContent: PropTypes.func.isRequired,
    saveContent: PropTypes.func.isRequired,
    createOrUpdatePath: PropTypes.func.isRequired,
    // saveToArchive: PropTypes.func.isRequired,
    moveSubTree: PropTypes.func.isRequired,
    editPage: PropTypes.func.isRequired,
    cancelPage: PropTypes.func.isRequired,
    deletePage: PropTypes.func.isRequired,
  };
  const frontload = async (props) => await props.getContent({ key, label });
  const mapStateToProps = (state) => {
    return {
      user: state.auth.user,
      content: state.staticPage.html[key],
      isEditing: state.staticPage.isEditingPage,
    };
  };
  const mapDispatchToProps = (dispatch) => ({
    getContent: (...args) => dispatch(loadContent(...args)),
    saveContent: (...args) => dispatch(saveContent(...args)),
    createOrUpdatePath: (...args) => dispatch(createOrUpdatePagePath(...args)),
    // saveToArchive: (...args) => dispatch(savePathToArchive(...args)),
    moveSubTree: (...args) => dispatch(showPathMovementDialog(...args)),
    editPage: (...args) => dispatch(editPageContent(...args)),
    cancelPage: (...args) => dispatch(cancelPageContent(...args)),
    deletePage: (...args) => dispatch(deletePagePathAndContent(...args)),
  });
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    frontloadConnect(frontload, {
      onMount: true,
      onUpdate: false,
    })(StaticPage)
  );
}
